/**
 * Remote config — docs/API.md §3.
 *
 * Klientda birorta ham qattiq yozilgan narx yoki limit yo'q (qoida 22).
 * Hammasi shu hookdan. Adminka o'zgartirsa `config.updated` WS eventi keladi
 * va so'rov qayta bajariladi — DEPLOYSIZ.
 */

import type { ConfigResponse } from '@voice/api-client';
import { useQuery } from '@tanstack/react-query';

import { request } from '../api/client';

export const CONFIG_KEY = ['config'] as const;

export function useConfig() {
  return useQuery({
    queryKey: CONFIG_KEY,
    queryFn: () => request<ConfigResponse>('/config', { auth: false }),
    staleTime: 5 * 60 * 1000,
    retry: 2,
  });
}

/**
 * Bitta narx yoki limit.
 *
 * Fallback ATAYLAB YO'Q: agar config yuklanmagan bo'lsa, `undefined`
 * qaytadi va chaqiruvchi yuklanish holatini ko'rsatishi kerak. Fallback
 * qo'ysak — u qattiq yozilgan raqamga aylanadi va qoida 22 buziladi.
 */
export function useConfigValue<S extends keyof ConfigResponse>(
  section: S,
  key: string,
  // `unknown` allaqachon `undefined` ni o'z ichiga oladi — `| undefined`
  // yozish ortiqcha.
): unknown {
  const { data } = useConfig();
  if (!data) return undefined;
  const bucket = data[section];
  if (bucket && typeof bucket === 'object' && key in bucket) {
    return (bucket as Record<string, unknown>)[key];
  }
  return undefined;
}
